import React, { useEffect } from "react"
import TopBar from "../helpers/TopBar"
import Footer from "../helpers/Footer"
import "antd/dist/antd.less"
import "./styles.less"

type Props = {
  children: any
  menus?: boolean
}

declare var ga: any

const MainWrapper = ({ children, menus }: Props) => {
  useEffect(() => {
    if (typeof ga == "function") {
      ga("set", "location", window.location.href)
      ga("send", "pageview")
    }
  }, [])

  // Bot-prerender readiness gate. Only set window.__PRERENDER_READY__ once the
  // page body AND (when the shell is shown) the menu + footer have rendered, so
  // crawler snapshots include the full navigation/footer links. Child effects
  // (TopBar/Footer) run before this parent effect, so poll until all are ready.
  useEffect(() => {
    const w = window as any
    const ready = () =>
      w.__PRERENDER_PAGE_READY__ === true &&
      (!menus ||
        (w.__PRERENDER_TOPBAR_READY__ === true &&
          w.__PRERENDER_FOOTER_READY__ === true))

    if (ready()) {
      w.__PRERENDER_READY__ = true
      return
    }
    const id = setInterval(() => {
      if (ready()) {
        w.__PRERENDER_READY__ = true
        clearInterval(id)
      }
    }, 100)
    return () => clearInterval(id)
  }, [menus])

  return (
    <>
      {menus && <TopBar />}
      <div>{children}</div>
      {menus && <Footer />}
    </>
  )
}

export default MainWrapper
